import { render, staticRenderFns } from "./PlcButton.vue?vue&type=template&id=5d0bab5f&scoped=true&"
import script from "./PlcButton.vue?vue&type=script&lang=js&"
export * from "./PlcButton.vue?vue&type=script&lang=js&"
import style0 from "./PlcButton.vue?vue&type=style&index=0&id=5d0bab5f&scoped=true&lang=scss&"
import style1 from "./PlcButton.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0bab5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2141801166/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d0bab5f')) {
      api.createRecord('5d0bab5f', component.options)
    } else {
      api.reload('5d0bab5f', component.options)
    }
    module.hot.accept("./PlcButton.vue?vue&type=template&id=5d0bab5f&scoped=true&", function () {
      api.rerender('5d0bab5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/PlcButton.vue"
export default component.exports